export const favicon = {

};
